module.exports = __webpack_public_path__ + "media/favorite_job_offers/favorite_job_offers-0b1cb7bb.svg";